import {Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class OrganisationTagService extends BaseService {
    constructor(public http: HttpClient) {
        super('organisation-tag', http);
    }
}
